import store from '../store'

export function showDocMediaModal(modalType,nodeId) {	
	store.dispatch({type:'SHOW_DOC_MEDIA_MODAL',modalType,nodeId})
}

export function hideDocMediaModal() {	
	store.dispatch({type:'HIDE_DOC_MEDIA_MODAL'})
}
